export default function budgetErrors(code: string) {
  return ["PBBudgetCategoriesStaleData", "PBBudgetCategoriesInsufficientFunds"].includes(code) ? "errors." + code : ""
}
